import $ from 'jquery';
import * as d3 from 'd3';
import * as d3Symbol from 'd3-symbol-extra';
import { clampIndex } from './utils';
// import d3Ease from 'd3-ease';

export function findData(data){
  // Determine which variable to port in from the school's JSON file
  
  let chartableData = data.enrollment_states;

  return chartableData

  // const demographicsData = chartableData.map(year => {

  //     const thisYear = {
  //       'timescale': year.year,
  //       'total_expenses': year[`total_expenses`],
  //       'total_expenses_instruction': year[`total_expenses_instruction`],
  //       'total_revenue': year[`total_revenue`],
  //       'total_revenue_tuition': year[`total_revenue_tuition`],
  //       'net_assets_end': year[`net_assets_end`],
  //       'endowment_value_end': year[`endowment_value_end`],
  //       'tuition_revenue_ratio': year[`total_revenue_tuition`]/year[`total_revenue`],
  //       'current_ratio': year[`total_assets`]/year[`total_liabilities`],
  //       'operating_ratio': year[`total_expenses`]/year[`total_revenue`],
  //     }

  //     return thisYear;
  // });

  // return priceData;
}


export function runData(datafile) {
 const statesList = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY', 'foreign']
 // Loop states and set fill based on % of students attending by state
 for (let state of statesList) { 
  const amount = datafile['all'] - datafile['foreign'] - datafile['NR']

  const fillBoi = "rgb(105,123,159,0" + Math.min(datafile[state]*10/amount,1) + ")"

  const selector = '#outlines #' + state
  $(selector).css({fill:fillBoi})
  $(selector).css({strokeOpacity:".7"})


  if (datafile[state]*10/amount > .7) {
    $(selector).next().css({fill:'white'});
  } else {
    $(selector).next().css({fill:'black'})
  }
 }

 $("#map-international span").html(Math.round(datafile['foreign']*100/datafile['all']))
 const commas = d3.format(',');

 // set the dimensions and margins of the graph
 const margin = {top: 0, right: 20, bottom: 130, left: 0},
      height = 500 - margin.top - margin.bottom;

  const width = Math.min(660, $(window).width() - margin.left - margin.right);
  const barWidth = 25;
  const barSpace = 8;
  const chartHeight = 200;
  const chartWidth = Math.min(600, $(window).width() - margin.left - margin.right);

  const x = d3.scaleLinear()
            .domain([0, 100])
            .range([0, chartWidth]);

  const globalRacePool = ['white', 'black', 'hisp', 'asian', 'twomore', 'amerindalasknat', 'nathawpacisl', 'unknown'];
  const globalReadableRaces = ["WHITE","BLACK / AFRICAN-AMERICAN", "HISPANIC / LATINO", "ASIAN", "TWO OR MORE RACES", "NATIVE HAWAIIAN / PACIFIC ISLANDER", "AMERICAN INDIAN / ALASKA NATIVE",  "NO RACE REPORTED"];

  const raceColors = ['#00aeef', '#8531BA', '#E4C16F', '#E46F88','#6FE4CF', '#e9651b','#52b033', 'grey'];
  let rectangles = globalRacePool.map(function(race) {
    return {
      label: race,
      value: datafile[`enrollment_${race}`]/datafile['total_enrollment'] *100
    };
  })


 } // end rundata

 export default {findData,runData}